import { createContext } from 'react'

import type { DispensaryContextValue, DispensaryPromosContextValue } from './types'

export const DispensaryContext = createContext<DispensaryContextValue | null>(null)

export const DispensaryPromosContext = createContext<DispensaryPromosContextValue>(null)
